import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from 'components';
import { useTranslation } from 'react-i18next';
import { useApi } from 'hooks/useApi';
import ChooseCompanyApi from 'libs/api/admin/chooseCompany';

const api = new ChooseCompanyApi();

const useChooseCompany = (isMainPage = true) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const { data, loading, onChangeTableFilter } = useApi({
    resourceKey: 'companies',
    singleResourceKey: 'companies',
    api,
    isMainPage,
  });

  const columns = useMemo(() => {
    return [
      {
        title: t('Titolo'),
        dataIndex: 'title',
        width: 100,
        filterMode: 'tree',
        filterSearch: true,
        onFilter: (value, record) => record.title.includes(value),
      },
      {
        title: '',
        dataIndex: 'value',
        align: 'right',
        width: 120,
        render: (data, row) => (
          <a href={data} target={'_blank'} rel='noopener noreferrer'>
            <Button>Aprire</Button>
          </a>
        ),
      },
    ];
  }, [t, pathname]);

  return {
    columns,
    data,
    loading,
    onChangeTableFilter,
  };
};

export default useChooseCompany;
